import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Detalhes da oferta',
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Definir o gasto mínimo e o desconto em %',
      qualifying_criteria: {
        title: 'Valor mínimo de gasto',
        description: 'Definir o valor mínimo de gasto',
      },
      details: {
        title: 'Desconto em %',
        description: 'Definir o valor de desconto que os clientes terão na sua encomenda',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Definir os artigos elegíveis e o desconto em %',
      qualifying_criteria: {
        title: 'Artigos com desconto',
        description: 'Selecione os artigos nos quais está a aplicar desconto.',
      },
      details: {
        title: 'Desconto em %',
        description: 'Definir o valor de desconto que os clientes terão na sua encomenda',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Definir os artigos elegíveis e o desconto em {{currency}}',
      qualifying_criteria: {
        title: 'Artigos com desconto',
        description: 'Selecione os artigos nos quais está a aplicar desconto.',
      },
      details: {
        title: 'Desconto em {{currency}}',
        description: 'Definir o valor de desconto que os clientes terão na sua encomenda',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Definir o gasto mínimo e o desconto em {{currency}}',
      qualifying_criteria: {
        title: 'Valor mínimo de gasto',
        description: 'Definir o valor mínimo de gasto',
      },
      details: {
        title: 'Desconto em {{currency}}',
        description: 'Definir o valor de desconto que os clientes terão na sua encomenda',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Definir o gasto mínimo e os artigos gratuitos',
      qualifying_criteria: {
        title: 'Valor mínimo de gasto',
        description: 'Definir o valor que o cliente tem de gastar para obter o artigo gratuito.',
      },
      details: {
        title: 'Artigos gratuitos:',
        description: 'Selecione o artigo gratuito (ou artigos) à escolha do cliente.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: 'Escolher os requisitos da oferta',
      qualifying_criteria: {
        title: 'Artigos elegíveis',
        description: 'Selecione os artigos que o cliente tem de encomendar para obter o artigo gratuito.',
      },
      details: {
        title: 'Artigos gratuitos:',
        description: 'Selecione o artigo gratuito (ou artigos) à escolha do cliente.',
      },
    },
    [OFFER_KIND.BOGO]: {
      title: 'Escolher os requisitos da oferta',
      qualifying_criteria: {
        title: 'Artigos elegíveis',
        description: 'Selecione a categoria a partir da qual o cliente tem de escolher para obter um artigo gratuito.',
      },
      details: {
        title: 'Artigo gratuito',
        description:
          'Os clientes podem selecionar o segundo artigo a partir dos artigos elegíveis escolhidos. O cliente receberá gratuitamente o mais barato dos dois artigos.',
      },
    },
  },
};
